import { css } from "lit";

export const sharedStyles = css`
    :host {
        display: block;
        line-height: 1.5;
    }

    :host * {
        outline: none !important;
    }

    :host *, 
    :host *::after, 
    :host *::before {
        box-sizing: border-box;
    }

    h1, h2, h3, h4, h5, h6, p, ul {
        margin-top: 0;
    }

    p, ul {
        margin-bottom: 1rem;
    }

    h1, .h1, 
    h2, .h2, 
    h3, .h3, 
    h4, .h4, 
    h5, .h5, 
    h6, .h6 {
        display: block;
        margin-bottom: .5rem;
        font-family: var(--font-lilita);
        font-weight: 400;
        line-height: 1.2;
    }

    a {
        text-decoration: none;
    }

    .d-block {
        display: block !important;
    }

    .d-none {
        display: none !important;
    }

    .d-flex {
        display: flex !important;
    }

    .w-100 {
        width: 100% !important;
    }

    .mb-3 {
        margin-bottom: 1rem !important;
    }

    h1, .h1 {
        font-size: var(--h2-font-size);
    }

    h2, .h2 {
        font-size: var(--h3-font-size);
    }

    h3, .h3 {
        font-size: var(--h4-font-size);
    }

    h4, .h4 {
        font-size: var(--h5-font-size);
    }

    .text-reset {
        color: inherit !important;
    }

    .text-center {
        text-align: center !important;
    }

    .text-uppercase {
        text-transform: uppercase !important;
    }

    .small {
        font-size: 80%;
        font-weight: 400;
    }

    .position-relative {
        position: relative !important;
    }

    @media (min-width: 992px) {
        h1, .h1 {
            font-size: var(--h1-font-size);
        }

        h2, .h2 {
            font-size: var(--h2-font-size);
        }

        h3, .h3 {
            font-size: var(--h3-font-size);
        }

        h4, .h4 {
            font-size: var(--h4-font-size);
        }

        .w-lg-auto {
            width: auto !important;
        }
    }
`;
